import React from "react";
import { useContext } from "react";
import { LangContext } from "../App";
import "bootstrap/dist/css/bootstrap.css";

const Pdf = () => {
  const language = useContext(LangContext);
  let pdfURL = "";

  language === "pl"
    ? (pdfURL = "https://michaljaskulski.pl/files/MichalJaskulski_pl.pdf")
    : (pdfURL = "https://michaljaskulski.pl/files/MichalJaskulski_en.pdf");

  return (
    <div className="bodyBackground">
      <iframe title="jaskulski" src={pdfURL} width="100%" height="800px" />
    </div>
  );
};
export default Pdf;
